import React from 'react';
import moment from 'moment';
import classNames from 'classnames';
import {trans} from './utils';


export default class ExtraInfo extends React.Component {

  constructor (props) {
    super(props);
    let selected = null;
    if (props.poi.extra.length > 0) {
      let today = props.poi.extra.find(
        day => equalDate(new Date(day.date*1000), new Date()));
      selected = today != null ? today.date : props.poi.extra[0].date;
    }
    this.state = {selected};
  }

  render () {
    let {name, extra} = this.props.poi;

    let nav = extra.map(day => {
        let fmt = moment(day.date*1000).format('dddd'),
            cls = classNames({selected: this.state.selected === day.date});
        return (
          <li className={cls} key={day.date}
              onClick={() => this.setState({selected: day.date}) }>
            <span>{fmt}</span>
          </li>
        );
    });

    let day = extra.find(d => d.date === this.state.selected),
        schedule = null;

    let cnt = 0;
    if (day != null) schedule = day.events.map(event => {
      return (
        <li key={(cnt++) + '__' + event.name}>
          <span className="time">
            {`${fmtTime(event.from)} - ${fmtTime(event.to)}`}
          </span>
          <div>
            <span className="name">{ truncStr(event.name, 100) }</span>
            <span className="speaker">{ fmtSpeaker(event.speaker) }</span>
          </div>
        </li>
      );
    });


    return (
      <div className="ExtraInfo">
        <h2>{ trans(this.props.lang, name) }</h2>
        <ul className="navigation">
          {nav}
        </ul>
        <ul className="schedule">
          {schedule}
        </ul>
      </div>
    );
  }
}

function fmtTime(t) {
  let hours = Math.floor(t / 60), minutes = (t % 60);
  if (hours < 10) {
    return t % 60 === 0 ? `0${hours}:00` : `0${hours}:${minutes}`;
  } else {
    return t % 60 === 0 ? `${hours}:00` : `${hours}:${minutes}`;
  }
};

function truncStr(str, maxLength) {
  if (str == null) return '';
  if (str.length > maxLength) {
    return `${str.substr(0, maxLength)}...`;
  } else {
    return str;
  }
}

function fmtSpeaker(speaker) {
  return speaker == null ? '' : speaker.split('\\');
}

function equalDate(d1, d2) {
  return d1.getYear() === d2.getYear() &&
         d1.getMonth() === d2.getMonth() &&
         d1.getDate() === d2.getDate();
}

